import createField from '../../utils/factory/createField'
import {
  faFileAlt,
  faClipboardCheck,
  faBuilding,
  faUser,
  faCalendarAlt,
  faMoneyBillWave,
  faBoxOpen,
  faFileSignature,
  faTools,
  faHashtag,
} from '@fortawesome/free-solid-svg-icons'

export const contractFields = [
  {
    section: 'Informações',
    fields: [
      createField({
        id: 'contract.name',
        label: 'Contrato',
        type: 'text',
        placeholder: 'Digite o nome do contrato',
        icon: faFileSignature,
      }),
      createField({
        id: 'contract.number',
        label: 'Número',
        type: 'text',
        placeholder: 'Digite o número do contrato',
        icon: faFileAlt,
      }),
      createField({
        id: 'contract.contract_type_id',
        label: 'Tipo',
        type: 'select',
        placeholder: 'Selecione o tipo',
        icon: faClipboardCheck,
        isClearable: true,
      }),
      createField({
        id: 'contract.contract_status_id',
        label: 'Status',
        type: 'select',
        placeholder: 'Selecione o status',
        icon: faClipboardCheck,
        isClearable: true,
      }),
      createField({
        id: 'contract.customer_id',
        label: 'Contratante',
        type: 'select',
        placeholder: 'Selecione um cliente cadastrado na tela de Clientes',
        icon: faUser,
        isClearable: true,
      }),
      createField({
        id: 'contract.is_same_customer_and_recipient',
        label: 'Contratante = Destinatário',
        type: 'select',
        placeholder:
          'O cliente contratante é o mesmo que o destinatário? Selecione uma opção',
        icon: faUser,
        options: [
          { value: true, label: 'Sim' },
          { value: false, label: 'Não' },
        ],
      }),
      createField({
        id: 'contract.recipient_customer_ids',
        label: 'Destinatário',
        type: 'select',
        placeholder: 'Selecione o cliente destinatário',
        icon: faUser,
        isMulti: true,
        fullWidth: true,
        disabled: true,
      }),
      createField({
        id: 'contract.object',
        label: 'Cláusula',
        type: 'textarea',
        fullWidth: true,
        placeholder: 'Digite a cláusula',
      }),
      createField({
        id: 'info.duration',
        label: 'Duração (meses)',
        type: 'number',
        placeholder: 'Digite a duração',
        icon: faHashtag,
      }),
      createField({
        id: 'info.max_duration',
        label: 'Duração Máxima (meses)',
        type: 'number',
        placeholder: 'Digite a duração máxima',
        icon: faHashtag,
      }),
      createField({
        id: 'info.start_date',
        label: 'Data Início',
        placeholder: 'Digite a data de início',
        type: 'date',
        fullWidth: true,
      }),
      createField({
        id: 'info.end_date',
        label: 'Data Término',
        placeholder: 'Digite a data de término',
        type: 'date',
      }),
      createField({
        id: 'info.max_end_date',
        label: 'Data Término Máxima',
        placeholder: 'Digite a data de término máxima',
        type: 'date',
      }),
    ],
  },
  {
    section: 'Itens',
    array: true,
    fields: [
      createField({
        id: 'items.alias',
        label: 'Nome',
        type: 'text',
        placeholder: 'Digite o Identificador',
        fullWidth: true,
        icon: faBoxOpen,
      }),
      createField({
        id: 'items.description',
        label: 'Descrição',
        type: 'textarea',
        placeholder: 'Digite a Descrição',
        fullWidth: true,
        icon: faBoxOpen,
      }),
      createField({
        id: 'items.quantity',
        label: 'Quantidade',
        type: 'text',
        placeholder: 'Digite a Quantidade',
        icon: faBoxOpen,
        isNumericFormat: true,
        formatType: 'integer',
      }),
      createField({
        id: 'items.price',
        label: 'Preço',
        type: 'number',
        isNumericFormat: true,
        placeholder: 'Digite o Preço',
        icon: faMoneyBillWave,
        formatType: 'currency',
      }),
    ],
  },
  {
    section: 'Serviços',
    array: true,
    fields: [
      createField({
        id: 'jobs.alias',
        label: 'Nome',
        type: 'text',
        placeholder: 'Digite o Identificador',
        fullWidth: true,
        icon: faTools,
      }),
      createField({
        id: 'jobs.description',
        label: 'Descrição',
        type: 'textarea',
        placeholder: 'Digite a Descrição',
        fullWidth: true,
        icon: faTools,
      }),
      createField({
        id: 'jobs.quantity',
        label: 'Quantidade',
        type: 'text',
        placeholder: 'Digite a Quantidade',
        icon: faBoxOpen,
        isNumericFormat: true,
        formatType: 'integer',
      }),
      createField({
        id: 'jobs.price',
        label: 'Preço',
        type: 'number',
        isNumericFormat: true,
        placeholder: 'Digite o Preço',
        icon: faMoneyBillWave,
        formatType: 'currency',
      }),
    ],
  },
]

export const contractEditFields = [
  {
    section: 'Informações',
    fields: [
      createField({
        id: 'name',
        label: 'Contrato',
        type: 'text',
        placeholder: 'Digite o nome do contrato',
        icon: faFileSignature,
      }),
      createField({
        id: 'number',
        label: 'Número',
        type: 'text',
        placeholder: 'Digite o número do contrato',
        icon: faFileAlt,
      }),
      createField({
        id: 'contract_type_id',
        label: 'Tipo',
        type: 'select',
        placeholder: 'Selecione o tipo',
        icon: faClipboardCheck,
      }),
      createField({
        id: 'contract_status_id',
        label: 'Status',
        type: 'select',
        placeholder: 'Selecione o status',
        icon: faClipboardCheck,
      }),
      createField({
        id: 'customer_id',
        label: 'Contratante',
        type: 'select',
        placeholder: 'Selecione o cliente contratante',
        icon: faUser,
        fullWidth: true,
        disabled: true,
      }),
      createField({
        id: 'recipient_customer_ids',
        label: 'Destinatário',
        type: 'select',
        placeholder: 'Selecione o cliente destinatário',
        icon: faUser,
        fullWidth: true,
        isMulti: true,
      }),
      createField({
        id: 'object',
        label: 'Cláusula',
        type: 'textarea',
        fullWidth: true,
        placeholder: 'Digite a cláusula do contrato',
        icon: faFileAlt,
      }),
      createField({
        id: 'info.duration',
        label: 'Duração (meses)',
        type: 'number',
        placeholder: 'Digite a duração',
        icon: faHashtag,
      }),
      createField({
        id: 'info.max_duration',
        label: 'Duração Máxima (meses)',
        type: 'number',
        placeholder: 'Digite a duração máxima',
        icon: faHashtag,
      }),
      createField({
        id: 'info.start_date',
        label: 'Data Início',
        placeholder: 'Digite a data de início',
        type: 'date',
        fullWidth: true,
      }),
      createField({
        id: 'info.end_date',
        label: 'Data Término',
        placeholder: 'Digite a data de término',
        type: 'date',
      }),
      createField({
        id: 'info.max_end_date',
        label: 'Data Término Máxima',
        placeholder: 'Digite a data de término máxima',
        type: 'date',
      }),
    ],
  },
]

export const contractDetailsFields = [
  {
    section: 'Informações',
    fields: [
      createField({
        id: 'contract.name',
        label: 'Contrato',
        type: 'text',
        placeholder: 'Digite o nome do contrato',
        icon: faFileSignature,
        disabled: true,
      }),
      createField({
        id: 'contract.number',
        label: 'Número',
        type: 'text',
        placeholder: 'Digite o número do contrato',
        icon: faFileAlt,
        disabled: true,
      }),
      createField({
        id: 'contract.original_start_date',
        label: 'Data Original de Início',
        placeholder: 'DD/MM/AAAA',
        type: 'date',
        mask: '99/99/9999',
        disabled: true,
      }),
      createField({
        id: 'contract.contract_type',
        label: 'Tipo',
        type: 'select',
        placeholder: 'Selecione o tipo',
        entity: 'contractType',
        column: 'id',
        columnLabel: 'name',
        icon: faClipboardCheck,
        disabled: true,
      }),
      createField({
        id: 'contract.contract_status',
        label: 'Status',
        type: 'select',
        entity: 'contractStatus',
        column: 'id',
        columnLabel: 'name',
        placeholder: 'Selecione o tipo',
        icon: faClipboardCheck,
        disabled: true,
      }),
      createField({
        id: 'contract.organization_name',
        label: 'Organização',
        type: 'select',
        entity: 'organization',
        column: 'id',
        columnLabel: 'name',
        placeholder: 'Selecione a organização',
        icon: faBuilding,
        disabled: true,
      }),
      createField({
        id: 'contract.customer_name',
        label: 'Contratante',
        type: 'select',
        placeholder: 'Selecione o cliente contratante',
        entity: 'customer',
        column: 'id',
        columnLabel: 'name',
        icon: faUser,
        disabled: true,
      }),
      createField({
        id: 'contract.object',
        label: 'Cláusula',
        type: 'textarea',
        fullWidth: true,
        placeholder: 'Digite o número do contrato',
        icon: faFileAlt,
        disabled: true,
      }),
      createField({
        id: 'info.duration',
        label: 'Duração',
        type: 'number',
        placeholder: 'Digite a duração',
        icon: faCalendarAlt,
        disabled: true,
      }),
      createField({
        id: 'info.max_duration',
        label: 'Duração Máxima',
        type: 'number',
        placeholder: 'Digite a duração máxima',
        icon: faCalendarAlt,
        disabled: true,
      }),
      createField({
        id: 'info.start_date',
        label: 'Data Início',
        placeholder: 'DD/MM/AAAA',
        type: 'date',
        mask: '99/99/9999',
        fullWidth: true,
        disabled: true,
      }),
      createField({
        id: 'info.total_amount',
        label: 'Valor Total',
        type: 'text',
        placeholder: 'Digite o valor total',
        icon: faMoneyBillWave,
        disabled: true,
      }),
      createField({
        id: 'info.end_date',
        label: 'Data Término',
        placeholder: 'DD/MM/AAAA',
        type: 'date',
        mask: '99/99/9999',
        disabled: true,
      }),

      createField({
        id: 'info.max_end_date',
        label: 'Data Término Máxima',
        placeholder: 'DD/MM/AAAA',
        type: 'date',
        mask: '99/99/9999',
        disabled: true,
      }),
    ],
  },
]
